import React from 'react';

import type { WalletType } from 'types/client/wallets';

import useAddChainClick from 'lib/web3/useAddChainClick';
import { Button } from 'toolkit/chakra/button';
import IconSvg from 'ui/shared/IconSvg';

import WalletSelectorModal from './WalletSelectorModal';

interface Props {
  source: 'Footer' | 'Top bar';
  onAddSuccess?: () => void;
}

const NetworkAddToWallet = ({ source, onAddSuccess }: Props) => {
  const [ isModalOpen, setIsModalOpen ] = React.useState(false);
  const handleAddChain = useAddChainClick({ source, onSuccess: onAddSuccess });

  const handleSelectWallet = React.useCallback(async(wallet: WalletType, provider: any) => {
    setIsModalOpen(false);
    await handleAddChain(wallet, provider);
  }, [ handleAddChain ]);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        borderWidth="1px"
        fontWeight="500"
        onClick={ () => setIsModalOpen(true) }
        _hover={{
          color: 'link.primary.hover',
          borderColor: 'link.primary.hover',
        }}
      >
        <IconSvg name="wallet" boxSize={ 4 }/>
        Add to Wallet
      </Button>
      <WalletSelectorModal
        open={ isModalOpen }
        onOpenChange={ (details) => setIsModalOpen(details.open) }
        onSelect={ handleSelectWallet }
      />
    </>
  );
};

export default React.memo(NetworkAddToWallet);
